{
  "(optional)": "(opţional)",
  "(required)": "(obligatoriu)"
}
